import styled from 'styled-components';

export const Container = styled.div`
  padding: 48px 0;
  background: #2b0000;
`;

export const Title = styled.div`
  font-weight: 500;
  font-size: 24px;
  line-height: 34px;
  text-align: center;
  color: #fff;
`;

export const Action = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
